import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalFunctions } from "../../../core/global-functions";

@Injectable({
    providedIn:'root'
})

export class TutorService{
    constructor(
        private _httpClient:HttpClient,
        private _globalFunctions:GlobalFunctions
    ){}
    
    
    updatePeofile(data:any):Observable<any>{
        return this._httpClient.patch('tutor/profile/about',data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }
    
    updateSubjects(data:any):Observable<any>{
        return this._httpClient.patch('tutor/profile/subjects',data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }

    updateLanguages(data:any):Observable<any>{
        return this._httpClient.patch('tutor/profile/languages',data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }
    
    updateEducation(data:any):Observable<any>{
        return this._httpClient.post('tutor/profile/education',data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }

    addEducation(data:any):Observable<any>{
        return this._httpClient.post('tutor/profile/education',data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }

    editEducation(id:any,data:any):Observable<any>{
        return this._httpClient.patch('tutor/profile/education/' + id,data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }

    deleteEducation(id:any):Observable<any>{
        return this._httpClient.delete('tutor/profile/education/' + id,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }
    
    updateExperience(data:any):Observable<any>{
        return this._httpClient.post('tutor/profile/experience',data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }

    addExperience(data:any):Observable<any>{
        return this._httpClient.post('tutor/profile/experience',data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }

    editExperience(id:any,data:any):Observable<any>{
        return this._httpClient.patch('tutor/profile/experience/' + id,data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }

    deleteExperience(id:any):Observable<any>{
        return this._httpClient.delete('tutor/profile/experience/' + id,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }
    
    updateRate(data:any):Observable<any>{
        return this._httpClient.patch('tutor/profile/rate',data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }

    updateAvailability(data:any):Observable<any>{
        return this._httpClient.patch('tutor/profile/availabilities',data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }

    updateProfile(data:any):Observable<any>{
        return this._httpClient.post('tutor/profile/submit',data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }

    uploadDocument(data:any):Observable<any>{
        return this._httpClient.post('tutor/profile/document',data,{ headers: this._globalFunctions.getAuthorizationHeader() });
    }

    skipStep(stepKey: string): Observable<any> {
        return this._httpClient.post('tutor/profile/skip/' + stepKey, {}, { headers: this._globalFunctions.getAuthorizationHeader() });
    }

    createProfile(data: any): Observable<any> {
        return this._httpClient.post('tutor/profile', data, { headers: this._globalFunctions.getAuthorizationHeader() });
    }

    updateProfileData(data: any): Observable<any> {
        return this._httpClient.patch('tutor/profile', data, { headers: this._globalFunctions.getAuthorizationHeader() });
    }

    getTutorById(id: string):Observable<any>{
        return this._httpClient.get('find-tutors/' + id, { headers: this._globalFunctions.getAuthorizationHeader() });
    }
}